import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Subtract: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 11.25h12v1.5H6v-1.5z'
        fill='currentColor'
      />
    </svg>
  </i>
);

Subtract.displayName = 'Subtract';
export default Subtract;
